<form class="decision-action-form" [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="hasFields">
  <p class="decision-action-form__eyebrow">{{ lang.translate('home.decisionActionForm.title') }}</p>
  <p class="decision-action-form__helper" *ngIf="formIntro as currentFormIntro">{{ currentFormIntro }}</p>

  <div class="decision-action-form__fields">
    <div class="decision-action-form__field" *ngFor="let entry of fieldEntries; trackBy: trackByFieldKey">
      <label class="decision-action-form__label" *ngIf="!isBooleanField(entry.field)" [for]="entry.inputId">
        {{ detailI18n.translateActionFieldLabel(action?.actionKey, entry.key, entry.field.label) }}
      </label>

      <label class="decision-action-form__checkbox" *ngIf="isBooleanField(entry.field)" [for]="entry.inputId">
        <input type="checkbox" [id]="entry.inputId" [formControlName]="entry.key" />
        <span>{{ detailI18n.translateActionFieldLabel(action?.actionKey, entry.key, entry.field.label) }}</span>
      </label>

      <textarea
        *ngIf="isTextareaField(entry.field)"
        class="form-control decision-action-form__control"
        [id]="entry.inputId"
        [formControlName]="entry.key"
        [placeholder]="detailI18n.translateActionFieldPlaceholder(action?.actionKey, entry.key, entry.field.placeholder) || ''"
        rows="4"
      ></textarea>

      <select
        *ngIf="isSelectField(entry.field)"
        class="form-select decision-action-form__control"
        [id]="entry.inputId"
        [formControlName]="entry.key"
      >
        <option value="">{{ lang.translate('home.decisionActionForm.selectPlaceholder') }}</option>
        <option *ngFor="let option of entry.field.options ?? []" [value]="option.value">{{ detailI18n.translateActionFieldOptionLabel(option.label) }}</option>
      </select>

      <input
        *ngIf="isStandardInputField(entry.field)"
        class="form-control decision-action-form__control"
        [id]="entry.inputId"
        [type]="resolveInputType(entry.field)"
        [formControlName]="entry.key"
        [placeholder]="detailI18n.translateActionFieldPlaceholder(action?.actionKey, entry.key, entry.field.placeholder) || ''"
      />

      <p class="decision-action-form__helper" *ngIf="entry.field.helperText">{{ detailI18n.translateActionFieldHelperText(action?.actionKey, entry.key, entry.field.helperText) }}</p>
      <p class="decision-action-form__error" *ngIf="isFieldInvalid(entry.key)">
        {{ lang.translate('home.decisionActionForm.required') }}
      </p>
    </div>
  </div>

  <div class="decision-action-form__field" *ngIf="requiresConfirmation">
    <label class="decision-action-form__checkbox" [for]="confirmationControlId">
      <input type="checkbox" [id]="confirmationControlId" [formControlName]="confirmationControlName" />
      <span>{{ confirmationLabel }}</span>
    </label>
    <p class="decision-action-form__error" *ngIf="isFieldInvalid(confirmationControlName)">
      {{ lang.translate('home.decisionActionForm.confirmRequired') }}
    </p>
  </div>

  <div class="decision-action-form__actions">
    <button type="submit" class="btn btn-primary" [disabled]="loading">
      {{ detailI18n.translateActionSubmitLabel(action) }}
    </button>
    <button type="button" class="btn btn-outline-secondary" [disabled]="loading" (click)="onCancel()">
      {{ lang.translate('home.decisionActionForm.cancel') }}
    </button>
  </div>
</form>